import React from 'react';
import apiConfig from 'utils/api/config';

interface IBusinessLink {
	children: string | React.ReactElement;
}

const BusinessLink = ({ children }: IBusinessLink) => {
	return <a href={apiConfig.links.businessLink}>{children}</a>;
};

export default BusinessLink;
